import React, {Fragment} from "react";
import styles from "./LegalAttributes.module.scss";
import {IAttribute} from "@connox/typescript-library/types/items/interface/Item.interface";
import {useTranslation} from "react-i18next";

const LegalAttributes: React.FC<{attributes: IAttribute[]}> = ({attributes}) => {
  const {t} = useTranslation();
  const legalAttributesArray = attributes.filter((attr) =>
    [100028, 100087, 100105, 100112, 100053, 100091, 100093, 100179].includes(attr.itemAttributeId),
  );

  return (
    <div className={styles.wrapper}>
      {legalAttributesArray.map((attr) => {
        return (
          <div key={attr.itemAttributeId}>
            {
              // Attribut-Spezialfall: Kinderartikel-Warnhinweise
              attr.itemAttributeId === 100028 && (
                <strong className={styles.attrWrapper}>
                  <span className={`icon icon-warning-children ${styles.noUnderThreeYearsIcon}`} />
                  <span className={styles.label}>{attr.label}</span>
                </strong>
              )
            }
            {
              // Attribut-Spezialfall: Kinderartikel-Warnhinweise
              attr.itemAttributeId === 100087 && (
                <strong>
                  <span>{attr.value}</span>
                </strong>
              )
            }
            {
              // Attribut-Spezialfall: Leuchten-Hinweis "Nur zur Dekoration"
              attr.itemAttributeId === 100105 && (
                <div className={styles.attrWrapper}>
                  <span className={`icon icon-warning-lightbulb ${styles.decoLampIcon}`} />
                  <span className={styles.label}>{attr.label}</span>
                </div>
              )
            }
            {
              //  Ggf. Hinweis auf nicht austauschbare Leuchtmittel
              attr.itemAttributeId === 100112 && (
                <Fragment>
                  <span>{attr.value}</span>
                </Fragment>
              )
            }
            {
              // Ggf. Entsorgungshinweis
              [100053, 100091, 100093, 100179].includes(attr.itemAttributeId) && (
                <Fragment>
                  <span>{t("general.pleaseNote")}</span>{" "}
                  <a href={t("url.wasteDisposalLink")} target="_blank" rel="noreferrer">
                    {t("customer.disposalInformation")}
                  </a>
                </Fragment>
              )
            }
          </div>
        );
      })}
    </div>
  );
};

export default LegalAttributes;
